import React from 'react';
import {getLabel} from '../../language'
// import Cropper from "react-cropper";
import {connect} from "react-redux";
import ImageCropper from '../Utils/imageCropper'

const mapStateToProps = (state, ownProps) => {
    return {
        anonymousMode: state.user.anonymousMode
    }
}

class SelectImagesBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
            image: this.props.defaultAvatar
        };
        this.selectImagesClick = this.selectImagesClick.bind(this);
        this.onImagesChange = this.onImagesChange.bind(this);
        this.removeImage = this.removeImage.bind(this);
        this._crop = this._crop.bind(this);
    }

    selectImagesClick() {
        document.getElementById('editor-img').click();
    }

    async _crop(croppedData) {
        const croppedImageUrl = window.URL.createObjectURL(croppedData);
        var formdata = new FormData();
        formdata.append("images", croppedData);

        this.setState({...this.state, imagePreview: croppedImageUrl, formData: formdata});
        this.props.newFormData(formdata)
    }

    onImagesChange(event) {
        const maxfilesize = 1024 * 5120
        let imagesPromises = [];
        let files = event.target.files;
        if (files[0].size > maxfilesize) {
            window.alert(getLabel(311));
            return false;
        } else {
            for (let i = 0; i < files.length; i++) {
                imagesPromises.push(new Promise((resolve) => {
                    let reader = new FileReader();
                    reader.onload = () => {
                        resolve({preview: reader.result, file: files[i]});
                    };
                    reader.readAsDataURL(files[i]);
                }));
            }
            Promise.all(imagesPromises)
                .then(result => {
                    this.setState({images: result, image: result});
                    this.props.onSelectImages(result);
                });
        }
    }

    removeImage(index) {
        const {images} = this.state;
        if (index > -1) {
            images.splice(index, 1);
            this.setState({
                images,
                image:[]
            })
        }
    }

    render() {
        const {anonymousMode} = this.props
        return (
            <div>
                <div className="addimagediv">
                    <div className="fileuploader fileuploader-theme-campaign">
                        <input type="hidden" name="fileuploader-list-files"/>
                        <input type="file" id="editor-img" accept="image/*" hidden={true} onChange={this.onImagesChange}
                               multiple/>
                        <div className="fileuploader-input">
                            <div className="fileuploader-input-caption">
                                <span>{this.state.images && this.state.images.length > 0 ? this.state.images.length + (getLabel(82)) : (getLabel(83))}</span>
                            </div>
                            <div className="fileuploader-input-button" onClick={this.selectImagesClick}>
                                <span>{getLabel(81)}</span></div>
                        </div>
                        <div className="fileuploader-items" hidden={!this.state.images.length}>
                            <ul className="fileuploader-items-list">
                                {
                                    this.state.images && this.state.images.map((item, index) => {
                                        return (
                                            <li key={index} className="fileuploader-item file-type-image file-ext-jpg">
                                                <div className="columns">
                                                    <div className="column-thumbnail">
                                                        <div className="fileuploader-item-image">
                                                            <img src={item.preview} height="36" width="36"></img>
                                                        </div>
                                                    </div>
                                                    <div className="column-title">
                                                        <div title={item.file.name}>{item.file.name}</div>
                                                        <span>180 KB</span></div>
                                                    <div className="column-actions">
                                                        <a className="fileuploader-action fileuploader-action-remove"
                                                           title="Remove" onClick={() => this.removeImage(index)}>
                                                            <i></i>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="progress-bar2"><span></span></div>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                {this.state.images.length > 0 && <div className='row' style={{display:"flex",justifyContent:"space-between"}}>
                    <div className='col-md-6 col-sm-12'>
                        <div>
                            <label
                                className={`${anonymousMode ? "cw" : ""}`}>{this.state.imagePreview && getLabel(221)}</label>
                        </div>
                        <div>
                            {!this.state.isAvatar &&
                            <ImageCropper
                                imageToCrop={this.state?.images[0]?.preview}
                                onImageCropped={(croppedImage) => this._crop(croppedImage)}
                            />}
                        </div>
                    </div>
                    <div className='col-md-6 col-sm-12'>
                        <div>
                            <label
                                className={`${anonymousMode ? "cw" : ""}`}>{this.state.imagePreview && getLabel(185)}</label>
                        </div>
                        <div>
                            {this.state.imagePreview &&
                            <img src={this.state.imagePreview} style={{opacity: 1,height: '130px', width: '130px'}}
                                 className="politicians-vote-img width-unset border-radius-10" alt=""/>
                            }
                            {this.state.isAvatar && !this.state.imagePreview &&
                            <img src={this.state.defaultAvatar} style={{opacity: 1,height: '130px', width: '130px'}}
                                 className="politicians-vote-img width-unset border-radius-10" alt=""/>
                            }
                        </div>
                    </div>
                </div>
                }
                {/*<div className="row">
                <div className="col-md-12">
                    <ul className="list-group">
                        <li className="list-group-item" hidden={!this.state.images.length}>
                            {
                                this.state.images && this.state.images.map((item, index) => {
                                    return (
                                        <img key={index} className="editor-img img-thumbnail" src={item.preview} alt="" />
                                    )
                                })
                            }
                        </li>
                        <li className="list-group-item">
                            <span className="ion-ios-camera" onClick={this.selectImagesClick}></span>
                            <input type="file" id="editor-img" accept="image/*"  hidden={true} onChange={this.onImagesChange} multiple/>
                        </li>
                    </ul>
                </div>
            </div>*/}
            </div>
        );
    }
}

export default connect(mapStateToProps, null)(SelectImagesBox);